import { createContext, useContext, useEffect, useRef, useState } from "react";
import type { CommonPropertiesContextType } from "./CommonPropertiesContextType";
import { useFetchData } from "../../hooks/useFetch/get";
import { ALL_BATCHES } from "../../entities/entities";
import { App } from "antd";

const CommonPropertiesContext = createContext<CommonPropertiesContextType | undefined>(undefined);

export const useCommonPropertiesContext = () => {
    const context = useContext(CommonPropertiesContext);

    if (!context) throw new Error("useCommonPropertiesContext must be used inside CommonPropertiesProvider");
    return context;
};

export const CommonPropertiesProvider = ({ children }: { children: React.ReactNode }) => {
    const { message: messageApi } = App.useApp();
    const [classes, setClasses] = useState<string[]>([])
    const [currentBatch, setCurrentBatch] = useState(ALL_BATCHES[0].label);
    const [choosedBatchToQA, setChoosedBatchToQA] = useState("");
    const dropdownWithBatchRef = useRef<{ current: HTMLButtonElement | null; width?: number }>(null);

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const [fetchClassesData, {
        data: classesData,
        error,
        clearError
    }] = useFetchData({
        query: "/classes",
        selectData: (data) => data.items,
    })

    useEffect(() => {
        fetchClassesData()
    }, [])

    useEffect(() => {
        if (classesData) setClasses(classesData)
    }, [classesData]);

    useEffect(() => {
        if (error) {
            messageApi.error(error.message);
            clearError?.();
        }
    }, [error, messageApi]);

    return (
        <>
           <CommonPropertiesContext.Provider
            value={{
                classes, setClasses,
                currentBatch, setCurrentBatch,
                choosedBatchToQA, setChoosedBatchToQA,
                isMenuOpen, setIsMenuOpen,
                dropdownWithBatchRef
            }}>
            {children}
        </CommonPropertiesContext.Provider>
        </>
    );
};
